import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const BankStatutoryModal = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    salaryBasis: '',
    salaryAmount: '',
    paymentType: '',
    pfContribution: '',
    pfNo: '',
    employeePfRate: '',
    pfAdditionalRate: '',
    pfTotalRate: '',
    esiContribution: '',
    esiNumber: '',
    employeeEsiRate: '',
    esiAdditionalRate: '',
    esiTotalRate: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    console.log('Bank & Statutory Data Saved:', formData);
    alert('Bank & Statutory details saved successfully! (Check console)');
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fw-semibold fs-4">Bank & Statutory</Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 py-4">
        <Form>
          {/* Basic Salary Information */}
          <h6 className="fw-semibold mb-3">Basic Salary Information</h6>
          <Row className="mb-4 g-3">
            <Col md={4}>
              <Form.Label className="fw-medium">
                Salary basis <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="salaryBasis"
                value={formData.salaryBasis}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Fixed">Fixed</option>
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Monthly">Monthly</option>
              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label className="fw-medium">Salary basis</Form.Label>
              <div className="input-group">
                <span className="input-group-text">$</span>
                <Form.Control
                  type="text"
                  name="salaryAmount"
                  value={formData.salaryAmount}
                  onChange={handleChange}
                  placeholder="0.00"
                />
              </div>
            </Col>
            <Col md={4}>
              <Form.Label className="fw-medium">Payment type</Form.Label>
              <Form.Select
                name="paymentType"
                value={formData.paymentType}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="Bank Transfer">Bank Transfer</option>
                <option value="Cash">Cash</option>
                <option value="Cheque">Cheque</option>
                <option value="UPI">UPI</option>
              </Form.Select>
            </Col>
          </Row>

          {/* PF Information */}
          <h6 className="fw-semibold mb-3">PF Information</h6>
          <Row className="mb-4 g-3">
            <Col md={4}>
              <Form.Label className="fw-medium">
                PF contribution <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="pfContribution"
                value={formData.pfContribution}
                onChange={handleChange}
              >
               <option value="">Select</option>
                <option value="1.75%">Employee Contribution</option>
                <option value="2%">Employeer Contribution</option>
                <option value="2%">Provided Fund Intrest</option>

              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label className="fw-medium">PF No</Form.Label>
              <Form.Control
                type="text"
                name="pfNo"
                value={formData.pfNo}
                onChange={handleChange}
                placeholder="Enter PF Number"
              />
            </Col>
            <Col md={4}>
              <Form.Label className="fw-medium">Employee PF rate</Form.Label>
              <Form.Control
                type="text"
                name="employeePfRate"
                value={formData.employeePfRate}
                onChange={handleChange}
                placeholder="12"
              />
            </Col>

            <Col md={4}>
              <Form.Label className="fw-medium">Additional rate</Form.Label>
              <Form.Select
                name="pfAdditionalRate"
                value={formData.pfAdditionalRate}
                onChange={handleChange}
              >
               <option value="">Select</option>
                <option value="0%">ESI</option>
                <option value="1%">EPF</option>
                <option value="1%">EPS</option>

              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label className="fw-medium">Total rate</Form.Label>
              <Form.Control
                type="text"
                name="pfTotalRate"
                value={formData.pfTotalRate}
                onChange={handleChange}
                placeholder="0"
              />
            </Col>
          </Row>

          {/* ESI Information */}
          <h6 className="fw-semibold mb-3">ESI Information</h6>
          <Row className="g-3">
            <Col md={4}>
              <Form.Label className="fw-medium">
                ESI contribution <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="esiContribution"
                value={formData.esiContribution}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="1.75%">Employee Contribution</option>
                <option value="2%">Employeer Contribution</option>
                <option value="2%">Maternity Benfits</option>

              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label className="fw-medium">ESI Number</Form.Label>
              <Form.Control
                type="text"
                name="esiNumber"
                value={formData.esiNumber}
                onChange={handleChange}
                placeholder="Enter ESI Number"
              />
            </Col>
            <Col md={4}>
              <Form.Label className="fw-medium">
                Employee ESI rate <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="employeeEsiRate"
                value={formData.employeeEsiRate}
                onChange={handleChange}
                placeholder="1.75"
              />
            </Col>

            <Col md={4}>
              <Form.Label className="fw-medium">Additional rate</Form.Label>
              <Form.Select
                name="esiAdditionalRate"
                value={formData.esiAdditionalRate}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="0%">ESI</option>
                <option value="1%">EPF</option>
                <option value="1%">EPS</option>

              </Form.Select>
            </Col>
            <Col md={4}>
              <Form.Label className="fw-medium">Total rate</Form.Label>
              <Form.Control
                type="text"
                name="esiTotalRate"
                value={formData.esiTotalRate}
                onChange={handleChange}
                placeholder="0"
              />
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-0 px-4 pb-4">
        <Button variant="light" className="px-4" onClick={onHide}>
          Cancel
        </Button>
        <Button
          style={{ backgroundColor: '#FF6B00', borderColor: '#FF6B00' }}
          className="px-4"
          onClick={handleSave}
        >
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BankStatutoryModal;